import Icon from "components/AppIcon";
import Button from "components/ui/Button";
import { useState } from "react";

function formatDate(utcDate) {
    const d = new Date(utcDate);
    return new Intl.DateTimeFormat('en-GB', {
        dateStyle: 'short',
        timeStyle: 'short',
        timeZone: 'UTC',
        hour12: true
    }).format(d);

}


export default function ScanlogModal({ onClose, alldata = [] }) {
    const [exportLoading, setExportLoading] = useState(false);
    const token = localStorage.getItem('token');
    const { scan_logs, ...batchDetails } = alldata
    const scanlogs = scan_logs
    const { ask_mobile: isAskmobile, scan_mobile_only: isScanMobileOnly, ask_geo: isAskLocation, unique_no: qrcodeUniqueNo, companyName: company_name, productTitle: product_name, batch_code, warning_limit: warningLimit, title: batchTitle } = batchDetails;
    const totalSuccessCount = scanlogs.filter((log) => log.status === "Success").length;
    const totalFailedCount = scanlogs.filter((log) => log.status === "Failed").length;
    const showButton = scanlogs.length > 0;
    const pin = batchDetails?.pin || "----"
    console.log("i am batchDetails", batchDetails)

    const handleExport = async () => {
        if (exportLoading) return;
        try {
            setExportLoading(true);
            const response = await fetch(`${import.meta.env.VITE_APP_ADMINURL}/api/exportScanlog/${qrcodeUniqueNo}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })

            if (!response.ok) return alert('Export Failed')

            const blob = await response.blob();
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `scanlog.${qrcodeUniqueNo}.xlsx`;
            link.click();
            window.URL.revokeObjectURL(link.href);
        } finally {
            setExportLoading(false);
        }
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-modal p-4">
            <div className="bg-surface rounded-lg shadow-floating max-w-5xl w-full max-h-[90vh] overflow-hidden">
                {/* header  */}
                <div className="px-6 py-4 border-b border-border flex items-center justify-between">
                    <h2 className="text-xl font-heading font-semibold text-text-primary">Scanlogs</h2>
                    <div className="flex gap-2">
                        {showButton &&
                            <Button onClick={handleExport} className="text-white" iconName="Download" loading={exportLoading}>
                                <span>Export</span>
                            </Button>
                        }
                        <button
                            onClick={onClose}
                            className="p-2 hover:bg-background rounded-lg nav-transition"
                        >
                            <Icon name="X" size={20} color="var(--color-text-secondary)" />
                        </button>
                    </div>
                </div>

                {/* content */}

                <div className="max-h-[75vh]">
                    <div className="grid grid-cols-2 my-4 px-4 gap-2">
                        <div>
                            <span className="font-semibold"> Company Name </span> : {company_name}
                        </div>
                        <div>
                            <span className="font-semibold">Product Name </span> : {product_name}
                        </div>
                        <div>
                            <span className="font-semibold">Qr Unique No</span> : {qrcodeUniqueNo}
                        </div>
                        <div>
                            <span className="font-semibold">Batch Code </span> : {batch_code}
                        </div>
                        <div>
                            <span className="font-semibold">Pin</span> : {pin}
                        </div>
                        <div>
                            <span className="font-semibold">Warning Limit</span> : {warningLimit}
                        </div>
                        <div>
                            <span className="font-semibold">Batch Title</span> : {batchTitle}
                        </div>
                        <div className="flex gap-2">
                            {isAskmobile &&
                                <span className={`badge`}>Ask Mobile Number</span>
                            }
                            {isAskLocation &&
                                <span className={`badge`}>Ask Location</span>
                            }
                            {isScanMobileOnly &&
                                <span className={`badge`}>Mobile Only Scan</span>
                            }
                        </div>
                    </div>

                    <div className="flex w-full" >
                        <div className="grid grid-cols-2 flex-1 px-6 py-2 rounded-r-full bg-green-300">
                            <div>
                                <h1 className="text-xs">Successful Scans</h1>
                                <p className="text-2xl font-bold">{totalSuccessCount}</p>
                            </div>
                            <div className="flex justify-end items-center">
                                <Icon name="CircleCheckBig" size={32} />
                            </div>
                        </div>
                        <div className="grid grid-cols-2 flex-1 px-6 py-2 rounded-l-full  bg-red-300">
                            <div>
                                <h1 className="text-xs">Failed Scans</h1>
                                <p className=" text-2xl font-bold "> {totalFailedCount} </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <Icon name="ShieldBan" size={32} />
                            </div>
                        </div>
                    </div>

                    <div className="max-h-[40vh] overflow-auto">
                        <table className="w-full text-center border-spacing-1 qrdata text-sm">
                            <thead className="bg-gray-50 border-b border-border">
                                <tr className="sticky-header">
                                    <th>ID</th>
                                    <th>IP Address</th>
                                    <th>Longitude</th>
                                    <th>Latitude</th>
                                    <th>location</th>
                                    <th>Mobile Number</th>
                                    <th>Status</th>
                                    <th>Scanned At</th>
                                </tr>
                            </thead>
                            <tbody>
                                {scanlogs.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" className="p-4 text-center" >
                                            No records Found
                                        </td>
                                    </tr>
                                ) : (

                                    scanlogs.map((log, index) => (
                                        <tr key={log.id} className="border-t">
                                            <td>{index + 1}</td>
                                            <td>{log.ip_address}</td>
                                            <td>{log.latitude || "-"}</td>
                                            <td>{log.longitude || "-"}</td>
                                            <td>{log.location || "-"}</td>
                                            <td>{log.mobile_number || "-"}</td>
                                            <td><span className={`${log.status === 'Success' ? "bg-green-400 " : "bg-red-400"} text-black px-2 py-1 rounded-full text-xs`}>{log.status}</span></td>
                                            <td>{formatDate(log.createdAt)}</td>
                                        </tr>
                                    ))
                                )
                                }

                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    )
}
